var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { ChangeDetectorRef, ComponentFactoryResolver, EventEmitter, QueryList, TemplateRef, ViewContainerRef } from '@angular/core';
import { PageEvent } from '@angular/material';
import { Observable } from 'rxjs';
var DataListSimpleCellComponent = /** @class */ (function () {
    function DataListSimpleCellComponent() {
    }
    return DataListSimpleCellComponent;
}());
export { DataListSimpleCellComponent };
var DataListCellRendererDirective = /** @class */ (function () {
    function DataListCellRendererDirective(template) {
        this.template = template;
    }
    return DataListCellRendererDirective;
}());
export { DataListCellRendererDirective };
var DataListCellPlaceholderDirective = /** @class */ (function () {
    function DataListCellPlaceholderDirective(viewContainer) {
        this.viewContainer = viewContainer;
    }
    return DataListCellPlaceholderDirective;
}());
export { DataListCellPlaceholderDirective };
var DataListTableComponent = /** @class */ (function () {
    function DataListTableComponent(changeDetector, componentFactoryResolver) {
        this.changeDetector = changeDetector;
        this.componentFactoryResolver = componentFactoryResolver;
        // Emitted when page nubmer or items per page is changed
        this.onPage = new EventEmitter();
        // Emitted when sort direction or column changed
        this.onSort = new EventEmitter();
        this.cellPlaceholders = new Map();
        this.cellRenderers = new Map();
        this.columnConfig = new Map();
    }
    Object.defineProperty(DataListTableComponent.prototype, "data", {
        // Observable data stream to be coerced into a dataSource
        set: function (value) {
            if (value) {
                this.dataSource = new SimpleDataSource(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataListTableComponent.prototype, "config", {
        // Table configuration
        set: function (value) {
            var _this = this;
            this.columns = value || [];
            this.columnConfig.clear();
            this.columns.forEach(function (column) { return _this.columnConfig.set(column.key, column); });
            this.displayedColumns = this.columns.map(function (value) { return value.key; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataListTableComponent.prototype, "sort", {
        // Allows passing in a loaded sort state
        set: function (value) {
            var _a = value ? value.split(' ') : [undefined, undefined], active = _a[0], direction = _a[1];
            this.sortActive = active;
            this.sortDirection = direction ? direction.toLowerCase() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataListTableComponent.prototype, "cell", {
        // Cells rendered in the table.
        set: function (values) {
            var _this = this;
            this.cellPlaceholders.clear();
            if (values) {
                values.forEach(function (cell) {
                    var cells = _this.cellPlaceholders.get(cell.dataListCellPlaceholder) || [];
                    _this.cellPlaceholders.set(cell.dataListCellPlaceholder, cells.concat(cell));
                });
            }
            this.rerender();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataListTableComponent.prototype, "renderers", {
        // Custom cell renderers from the parent
        set: function (values) {
            var _this = this;
            this.cellRenderers.clear();
            if (values) {
                values.forEach(function (value) {
                    _this.cellRenderers.set(value.dataListCellRenderer, value);
                });
            }
            this.rerender();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Update all the cell placeholders passed to CDK with our custom renderers
     */
    DataListTableComponent.prototype.rerender = function () {
        var _this = this;
        this.cellPlaceholders.forEach(function (placeholders, key) {
            var renderer = _this.cellRenderers.get(key);
            var config = _this.columnConfig.get(key);
            placeholders.forEach(function (cell) {
                cell.viewContainer.clear();
                if (renderer) {
                    cell.viewContainer.createEmbeddedView(renderer.template, { $implicit: cell.payload });
                }
                else {
                    var payload = cell.payload || {};
                    var rendered = config.render ? config.render(payload) : payload[key];
                    _this.createSimpleCell(cell, rendered);
                }
            });
        });
        this.changeDetector.detectChanges();
    };
    /**
     * Just display the column value (or some subset of the row) - no component necessary
     */
    DataListTableComponent.prototype.createSimpleCell = function (target, payload) {
        var factory = this.componentFactoryResolver.resolveComponentFactory(DataListSimpleCellComponent);
        var cell = target.viewContainer.createComponent(factory);
        cell.instance.value = payload;
        return cell;
    };
    return DataListTableComponent;
}());
export { DataListTableComponent };
var SimpleDataSource = /** @class */ (function (_super) {
    __extends(SimpleDataSource, _super);
    function SimpleDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    SimpleDataSource.prototype.connect = function () {
        return this.data;
    };
    SimpleDataSource.prototype.disconnect = function () {
        // lint
    };
    return SimpleDataSource;
}(DataSource));
export { SimpleDataSource };
